import {Injectable} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {LayerUtilService} from './layer-util.service';
import {SpatialUtilService} from '../services/spatial-util.service';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
    providedIn: 'root'
})
export class EnlargementLayerService {
    private readonly layerId = 'enlargementFeatureLayer_layer';

    private readonly layerSelector = `#${this.layerId}`;

    private readonly featureClass = 'enlargement';

    private readonly featureIdAttrName = this.layerUtilService.getFeatureIdAttrName(this.featureClass);

    private readonly featureTypeAttrName = this.layerUtilService.getFeatureTypeAttrName(this.featureClass);

    private svgStyle: string;

    private trustedSvgStyle: SafeHtml;

    constructor(
        private domSanitizer: DomSanitizer,
        private layerUtilService: LayerUtilService,
        private spatialUtilService: SpatialUtilService
    ) {}

    getSvgStyle(): SafeHtml {
        const scaleFactor = this.layerUtilService.getPixelScaleFactor();
        if (scaleFactor === 0) {
            return '';
        }

        const newSvgStyle =
            `${this.layerSelector} path[${this.featureTypeAttrName}="1"],` +
            `${this.layerSelector} path[${this.featureTypeAttrName}="2"] {
            stroke: ${this.layerUtilService.showFeatures() ? 'rgb(178,178,178)' : 'transparent'};
            stroke-opacity: 1.0;
            stroke-width: 1.2;
            fill: none;
        }`;

        if (newSvgStyle === this.svgStyle) {
            return this.trustedSvgStyle;
        }

        this.svgStyle = newSvgStyle;

        this.trustedSvgStyle = this.domSanitizer.bypassSecurityTrustHtml(this.svgStyle);

        return this.trustedSvgStyle;
    }

    init() {
        const enlargementFeatureLayer = this.spatialUtilService.getEnlargementMapLayer();

        this.layerUtilService.addLayerEventHandler(enlargementFeatureLayer, 'graphic-node-add', (evt: {graphic: any; node: any}) => {
            const featureId = evt.graphic.attributes.id;
            evt.node.setAttribute('id', this.layerUtilService.getFeatureNodeId(this.featureClass, featureId));
            evt.node.setAttribute(this.featureTypeAttrName, `${evt.graphic.attributes.type}`);
            evt.node.setAttribute(this.featureIdAttrName, `${featureId}`);
            this.layerUtilService.setSelectedAttr(evt.node, this.featureClass, featureId);
        });

        this.layerUtilService.addLayerEventHandler(enlargementFeatureLayer, 'edits-complete', () => {
            const enlargementIds = this.spatialUtilService.getEnlargementGraphics().map(g => g.attributes.id);

            document.querySelectorAll(`${this.layerSelector} path[${this.featureIdAttrName}]`).forEach(path => {
                const enlargementId = parseInt(path.getAttribute(this.featureIdAttrName));
                if (!enlargementIds.includes(enlargementId)) {
                    path.parentNode.removeChild(path);
                }
            });
        });

        this.layerUtilService.addLayerEventHandler(enlargementFeatureLayer, 'mouse-over', (evt: any) => {
            this.layerUtilService.onMouseOver(this.featureClass, evt);
        });

        this.layerUtilService.addLayerEventHandler(enlargementFeatureLayer, 'mouse-out', (evt: any) => {
            this.layerUtilService.onMouseOut(this.featureClass, evt);
        });

        return enlargementFeatureLayer;
    }
}
